<template>
    <div class="my-schedule-status-wrap">
      <div class="status-box-wrap">
        <div class="status-box">
          <div class="status-title">To Do</div>
          <div class="status-detail-list">
            <button type="button"
                    class="status-detail overdue"
                    @click="onStatusSelected(myScheduleStatus.todo.overdue)">
              <span class="status-text">Overdue</span>
              <span class="num">{{ myScheduleStatus.todo.overdue.length }}</span>
            </button>
            <button type="button"
                    class="status-detail today"
                    @click="onStatusSelected(myScheduleStatus.todo.today)">
              <span class="status-text">Today</span>
              <span class="num">{{ myScheduleStatus.todo.today.length }}</span>
            </button>
            <button type="button"
                    class="status-detail scheduled"
                    @click="onStatusSelected(myScheduleStatus.todo.scheduled)">
              <span class="status-text">Scheduled</span>
              <span class="num">{{ myScheduleStatus.todo.scheduled.length }}</span>
            </button>
            <button type="button"
                    class="status-detail scheduled"
                    @click="onStatusSelected(myScheduleStatus.todo.tbd)">
              <span class="status-text">TBD</span>
              <span class="num">{{ myScheduleStatus.todo.tbd.length }}</span>
            </button>
          </div>
        </div>
        <div class="status-box">
          <div class="status-title">In Progress</div>
          <div class="status-detail-list">
            <button type="button"
                    class="status-detail overdue"
                    @click="onStatusSelected(myScheduleStatus.inProgress.overdue)">
              <span class="status-text">Overdue</span>
              <span class="num">{{ myScheduleStatus.inProgress.overdue.length }}</span>
            </button>
            <button type="button"
                    class="status-detail today"
                    @click="onStatusSelected(myScheduleStatus.inProgress.today)">
              <span class="status-text">Today</span>
              <span class="num">{{ myScheduleStatus.inProgress.today.length }}</span>
            </button>
            <button type="button"
                    class="status-detail scheduled"
                    @click="onStatusSelected(myScheduleStatus.inProgress.scheduled)">
              <span class="status-text">Scheduled</span>
              <span class="num">{{ myScheduleStatus.inProgress.scheduled.length }}</span>
            </button>
            <button type="button"
                    class="status-detail scheduled"
                    @click="onStatusSelected(myScheduleStatus.inProgress.tbd)">
              <span class="status-text">TBD</span>
              <span class="num">{{ myScheduleStatus.inProgress.tbd.length }}</span>
            </button>
          </div>
        </div>
        <div class="status-box">
          <div class="status-title">Completed</div>
          <div class="status-detail-list">
            <button type="button"
                    class="status-detail black done"
                    @click="onStatusSelected(myScheduleStatus.completed.done)">
              <span class="status-text">Done</span>
              <span class="num">{{ myScheduleStatus.completed.done.length }}</span>
            </button>
            <button type="button"
                    class="status-detail black cancelled"
                    @click="onStatusSelected(myScheduleStatus.completed.cancelled)">
              <span class="status-text">Cancelled</span>
              <span class="num">{{ myScheduleStatus.completed.cancelled.length }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        myScheduleStatus: {
          todo: {
            overdue: [],
            scheduled: [],
            tbd: [],
            today: []
          },
          inProgress: {
            overdue: [],
            scheduled: [],
            tbd: [],
            today: []
          },
          completed: {
            done: [],
            cancelled: [],
          }
        }
      }
    },
    watch: {
      project: {
        deep: true,
        immediate: true,
        async handler(project) {
          const params = {
            pageSize: 0,
            updated: 'Y',
          }
  
          try {
            let response = await axios.post('/chatter/retrieveMyScheduleList', params, {
              headers: { Authorization: accessToken() }
            });

            console.log(response.data);

            response.data.list.sort((a, b) => new Date(b.updatedDate) - new Date(a.updatedDate));
  
            let myScheduleStatus = {
              todo: {
                overdue: [],
                scheduled: [],
                tbd: [],
                today: []
              },
              inProgress: {
                overdue: [],
                scheduled: [],
                tbd: [],
                today: []
              },
              completed: {
                done: [],
                cancelled: [],

              }
            }
  
            const today = new Date().toISOString().slice(0, 10);
            
            //mySchedule마다 status별로 push
            response.data.list.forEach(mySchedule => {
              if (mySchedule.status === 'TO_DO') {
                // 1. Overdue cases
                // Case 1 - Due date is before today
                if (mySchedule.dueDate !== '-' && this.compareDates(today, mySchedule.dueDate) > 0) {
                  myScheduleStatus.todo.overdue.push(mySchedule)
                  return;
                  // Case 2 - Start date is after today
                } else if (mySchedule.startDate !== '-' && this.compareDates(today, mySchedule.startDate) > 0) {
                  myScheduleStatus.todo.overdue.push(mySchedule)
                  return;
                }
  
                // 2. Scheduled cases
                if (mySchedule.startDate !== '-' && this.compareDates(today, mySchedule.startDate) < 0) {
                  myScheduleStatus.todo.scheduled.push(mySchedule)
                  return;
                }

                console.log(today);
                console.log(mySchedule.startDate);
                console.log(this.compareDates(today, mySchedule.startDate));

                // 3. Scheduled on today
                if (mySchedule.startDate !== '-' && this.compareDates(today, mySchedule.startDate) === 0) {
                  myScheduleStatus.todo.today.push(mySchedule)
                  return;
                }
  
                // 3. Cases not scheduled yet
                myScheduleStatus.todo.tbd.push(mySchedule)
              } else if (mySchedule.status === 'IN_PROGRESS') {
                // 1. Overdue cases - Due date is before today
                if (mySchedule.dueDate !== '-' && this.compareDates(today, mySchedule.dueDate) > 0) {
                  myScheduleStatus.inProgress.overdue.push(mySchedule)
                  return;
                }
  
                // 2. Scheduled cases
                if (mySchedule.dueDate !== '-' && this.compareDates(today, mySchedule.dueDate) < 0) {
                  myScheduleStatus.inProgress.scheduled.push(mySchedule)
                  return;
                }
  
                // 3. Scheduled on today
                if (mySchedule.dueDate !== '-' && this.compareDates(today, mySchedule.dueDate) === 0) {
                  myScheduleStatus.inProgress.today.push(mySchedule)
                  return;
                }
  
                // 3. Cases not scheduled yet
                myScheduleStatus.inProgress.tbd.push(mySchedule)
              } else if (mySchedule.status === 'DONE') {
                myScheduleStatus.completed.done.push(mySchedule);
              } else if (mySchedule.status === 'CANCELLED') {
                myScheduleStatus.completed.cancelled.push(mySchedule);
              }
            })
            this.myScheduleStatus = myScheduleStatus;
          } catch (error) {
            await this.showError(error);
          }
        }
      },
    },
    methods: {
      onStatusSelected(mySchedules) {
        this.$store.commit('mySchedule/setOccupied', true);
        this.$store.commit('mySchedule/setMySchedules', mySchedules);
        this.$store.commit('mySchedule/setTotal',mySchedules.length);
      }
    },
  }
  </script>
  
  <style scoped>
  .my-schedule-status-wrap {
      padding-top: max(2rem, 1.5625vw);
      padding-left: 2.0833vw;
      padding-right: 2.0833vw;
      padding-bottom: max(2.666rem, 2.0833vw);
      margin-bottom: 2rem;
      border-radius: 30px;
      background: linear-gradient(172deg, #2E2E38 0%, #40404B 100%);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
      font-family: 'NanumGothic';
  }
  
  .my-schedule-status-wrap .status-box-wrap {
      display: grid;
      grid-template-columns: 33.333% 33.333% 33.334%;
      gap: 0.666rem;
  }
  
  .my-schedule-status-wrap .status-box {
      padding: 1.333rem 0.933rem;
      border-radius: 14px;
      background: rgba(0, 0, 0, 0.30);
  }
  
  .my-schedule-status-wrap .status-box .status-title {
      padding-left: 0.4rem;
      color: #FFF;
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  .my-schedule-status-wrap .status-box .status-detail-list {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(140px, auto));
      gap: 0.4rem;
      margin-top: 0.933rem;
  }
  
  .my-schedule-status-wrap .status-box .status-detail {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: auto;
      padding: 0.466rem 0.533rem 0.466rem 0.8rem;
      border-radius: 34px;
      border: none;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.overdue {
      background-color: #FFDCDC;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.overdue:hover {
      background-color: #FFC0C0;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.scheduled {
      background-color: #FFF1BF;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.scheduled:hover {
      background-color: #FFE897;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.today {
      background-color: #E7E7EE;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.today:hover {
      background-color: #C4C4CD;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.black {
      background-color: #1B1B1B;
      border: 1px solid #1B1B1B;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.black:hover {
      border: 1px solid #747480;
  }
  
  .my-schedule-status-wrap .status-box .status-detail .num {
      display: inline-block;
      padding: 0.166rem 0.5rem;
      border-radius: 30px;
      background-color: #FFF;
      color: #2E2E38;
      font-size: 14px;
      font-weight: 700;
      line-height: 150%;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.black .num {
      background-color: #2E2E38;
      color: #FFF;
  }
  
  .my-schedule-status-wrap .status-box .status-detail .status-text {
      color: #2E2E38;
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.done .status-text {
      color: #CFDDFF;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.cancelled .status-text {
      color: #E4E4EA;
  }  
  .my-schedule-status-wrap .status-box .status-detail.gray {
      background-color: #E7E7EE;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.gray:hover {
      background-color: #C4C4CD;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.gray .num {
      background-color: #2E2E38;
      color: #FFF;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.done.gray .status-text {
      color: #1755CC;
  }
  
  .my-schedule-status-wrap .status-box .status-detail.cancelled.gray .status-text {
      color: #9696A0;
  }
  .my-schedule-status-wrap .my-schedule-status-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2rem;
  }
  
  .my-schedule-status-wrap .custom-select-box {
      position: relative;
      text-align: left;
      cursor: pointer;
      font-family: 'NanumGothic';
  }
  
  .my-schedule-status-wrap .custom-select-box .select {
      display: flex;
      align-items: center;
      gap: 0 0.933rem;
      width: 100%;
      height: 45px;
  }
  
  .my-schedule-status-wrap .custom-select-box .select .text {
      color: #FFF;
      font-family: 'NanumGothic';
      font-size: 30px;
      font-weight: 700;
      line-height: 150%;
  }
  
  .my-schedule-status-wrap .custom-select-box .select .project-id {
      color: rgba(255, 255, 255, 0.40);
      font-family: 'NanumGothic';
      font-size: 30px;
      font-weight: 400;
      line-height: 150%;
  }
  
  .my-schedule-status-wrap .custom-select-box .select .icon-arrow {
      display: block;
      width: 30px;
      height: 30px;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none"><path d="M24.002 11.5003L15.252 20.2503L6.50195 11.5003" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  }
  
  .my-schedule-status-wrap .opt-list {
      display: none;
      position: absolute;
      top: 4.333rem;
      left: 0;
      z-index: 150;
      width: 300px;
      max-height: 320px;
      padding: 0.666rem;
      border-radius: 16px;
      background-color: #FFF;
      box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
      list-style: none;
      overflow-y: auto;
  }
  
  .my-schedule-status-wrap .custom-select-box.active .opt-list {
      display: block;
  }
  
  .my-schedule-status-wrap .opt-list .opt-inner {
      padding: 0.866rem 1.333rem;
      border-radius: 10px;
      color: #747480;
      font-family: 'NanumGothic';
      font-size: 16px;
      font-weight: 500;
      line-height: 150%;
      cursor: pointer;
  }
  
  .custom-select-box .opt-item:hover .opt-inner {
      background-color: #E7E7EE;
      color: #2E2E38;
      font-weight: 700;
  }
  
  .my-schedule-status-wrap .my-schedule-status-header .btn-project-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 0 0.466rem;
      width: 130px;
      padding: 0.533rem 0.666rem 0.533rem 0.933rem;
      background-color: rgba(0, 0, 0, 0.30);
      border-radius: 50px;
      border: 1px solid #C4C4CD;
      color: #C4C4CD;
      font-family: 'NanumGothic';
      font-size: 12px;
      font-weight: 500;
      line-height: 150%;
  }
  
  .my-schedule-status-wrap .my-schedule-status-header .btn-project-list .text {
      white-space: nowrap;
  }
  
  .my-schedule-status-wrap .my-schedule-status-header .btn-project-list:hover {
      border: 1px solid #FFF;
      color: #FFF;
  }
  
  .my-schedule-status-wrap .my-schedule-status-header .btn-project-list .icon-arrow {
      display: block;
      width: 14px;
      height: 14px;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M11.083 5.75L6.99967 9.83333L2.91634 5.75" stroke="%23C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  }
  
  .my-schedule-status-wrap .my-schedule-status-header .btn-project-list:hover .icon-arrow {
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M11.083 5.75L6.99967 9.83333L2.91634 5.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  }
  
  .my-schedule-status-wrap .my-schedule-status-header .btn-project-list.active .icon-arrow {
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M11.083 9.25L6.99967 5.16667L2.91634 9.25" stroke="%23C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  }
  
  .my-schedule-status-wrap .my-schedule-status-header .btn-project-list.active:hover .icon-arrow {
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M11.084 9.25L7.00065 5.16667L2.91732 9.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  }
  
  .my-schedule-status-wrap .project-box-wrap {
      display: flex;
      flex-direction: column;
      gap: 0.933rem 0;
      margin-top: 4rem;
  }
  
  .my-schedule-status-wrap .project-box-wrap .project-box {
      padding: 2rem;
      background-color: #FFF;
      border-radius: 20px;
  }
  
  .my-schedule-status-wrap .project-box-wrap .project-box .project-title .title {
      font-size: 20px;
      font-weight: 700;
      margin-right: 0.66rem;
  }
  
  .my-schedule-status-wrap .project-box-wrap .project-box .project-title .sub-title {
      font-size: 20px;
      color: #747480;
  }
  
  .my-schedule-status-wrap .project-status-wrap {
      display: grid;
      grid-template-columns: 22.126% 33.805% 43.917%;
      margin-top: 1.06rem;
  }
  
  .my-schedule-status-wrap .project-status-wrap .status-box {
      background-color: transparent;
      border-radius: 0;
      border-right: solid 1px #DDDDE3;
      padding: 0 0.66rem;
  }
  
  .my-schedule-status-wrap .project-status-wrap .status-box:first-child {
      padding-left: 0;
  }
  
  .my-schedule-status-wrap .project-status-wrap .status-box:last-child {
      border: 0;
      padding-right: 0;
  }
  
  .my-schedule-status-wrap .project-status-wrap .status-box .status-title {
      color: #2E2E38;
      font-weight: 700;
      font-size: 14px;
  }
  </style>